
import CreateProduct from "./products/base/base";
import ListClients from "./clients/list";
import CreateNewClient from "./clients/create";
import EditClient from "./clients/edit";
import ICMSList from "./fiscal/taxes/template-icms/list";
import IpiList from "./fiscal/taxes/ipi/list";
import CreateBranch from "./branches/create";
import Edit from "./products/base/edit";
import NFeTransporter from "./fiscal/transporter";

import Afilliation from "./afilliation"

import Settings from "./settings";
import SalesConfig from "./settings/sale-config";
import BranchConfig from "./settings/branch-config";

import RegisterCertificateAccountant from "./accountant/registerCertificate";
import listClientsAccountant from "./accountant/list";
import EditClientsAccountant from "./accountant/edit";

import HomeAccountant from "./accountant/home";
import Help from "../../components/pages/help"

export {
  CreateProduct,
  ListClients,
  CreateNewClient,
  EditClient,
  CreateBranch,
  ICMSList,
  IpiList,
  Settings,
  Edit,
  NFeTransporter,
  SalesConfig,
  BranchConfig,
  RegisterCertificateAccountant,
  listClientsAccountant,
  EditClientsAccountant,
  HomeAccountant,
  Afilliation,
  Help
};



// WEBPACK FOOTER //
// ./src/components/pages/index.jsx